import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SystemService } from '@src/domain/services';

/** 系統資訊 */
interface SystemData extends SystemService.GetItemListByCategoryRespBo {}

export interface SystemState {
  systemData: SystemData | null;
}

/** 系統 */
export const systemSlice = createSlice({
  name: 'system',
  initialState: {
    /** 系統資訊 */
    systemData: null
  } as SystemState,
  reducers: {
    setSystemData(state, action: PayloadAction<SystemData>) {
      state.systemData = action.payload
    },
    clearSystemData(state) {
      state.systemData = null
    }
  },
});

export const systemReducer = systemSlice.reducer
export const systemActions = systemSlice.actions
